export default __webpack_public_path__ + "static/skills-tag-neutral-light-08bf2a4b4f68259d6c82d4309ec035c1caee3426165c89e8361895814b69a99c.png";